import FW from '../fw/fw';
import FccCaptions from '../accessibility/fcc';


export default class ModuleManagement {

  #rmp;
  //#firstHint = true;
  #overlayValidated = [];
  #openableTypes = ['quality', 'audio', 'captions', 'sharing', 'speed', 'related', 'chapters', 'info'];


  constructor(rmp) {
    this.#rmp = rmp;
  }

  get openableTypes() {
    return this.#openableTypes;
  }

  get overlayValidated() {
    return this.#overlayValidated;
  }

  set overlayValidated(updatedArray) {
    this.#overlayValidated = updatedArray;
  }

  #playPauseModule(event) {
    FW.eventStopPrevent(event);
    let paused;
    if (this.#rmp.linearAdOnStage) {
      paused = this.#rmp.adPaused;
    } else {
      paused = this.#rmp.paused;
    }
    if (paused) {
      this.#rmp.play().catch(error => {
        this.#rmp.rmpUtils.warning(1014, error);
      });
    } else {
      this.#rmp.pause();
    }
  }

  appendModuleSelection() {
    const overlays = this.#rmp.dom.container.querySelectorAll('.rmp-module-overlay');
    if (overlays.length > 0) {
      for (let i = 0, len = overlays.length; i < len; i++) {
        const overlay = overlays[i];
        const type = overlay.getAttribute('data-type');
        if (this.#overlayValidated.includes(type)) {
          continue;
        }
        this.#overlayValidated.push(type);
        const overlayMenuSelection = this.#rmp.dom[type + 'OverlayWrapper'].querySelector('.rmp-overlay-menu-selection');
        if (overlayMenuSelection) {
          // play/pause button
          this.#rmp.dom[type + 'OverlayPlayPause'] = FW.createElement(
            'button',
            'rmp-button rmp-i rmp-module-overlay-icons rmp-module-overlay-play-pause rmp-i-play',
            null,
            null
          );
          const playLabel = this.#rmp.labels.hint.play;
          const modulesPlayPause = this.#playPauseModule.bind(this);
          FW.addEvents(['touchend', 'click'], this.#rmp.dom[type + 'OverlayPlayPause'], modulesPlayPause);
          overlayMenuSelection.appendChild(this.#rmp.dom[type + 'OverlayPlayPause']);
          this.#rmp.rmpAccessible.button(this.#rmp.dom[type + 'OverlayPlayPause'], playLabel, true);

          // module buttons
          for (let i = 0, len = overlays.length; i < len; i++) {
            const overlay = overlays[i];
            const currentType = overlay.getAttribute('data-type');
            const className = 'rmp-button rmp-module-overlay-icons rmp-i rmp-i-' + currentType;
            const label = this.#rmp.labels.hint[currentType];
            const button = FW.createElement(
              'button',
              className,
              null,
              null
            );
            const onOverlayModuleButtonInteraction = this.open.bind(this, currentType, true);
            FW.addEvents(['touchend', 'click'], button, onOverlayModuleButtonInteraction);
            overlayMenuSelection.appendChild(button);
            this.#rmp.rmpAccessible.button(button, label, true);
          }

          // close button
          const overlayCloseButton = FW.createElement(
            'button',
            'rmp-button rmp-i rmp-i-close rmp-module-overlay-icons rmp-module-overlay-close',
            null,
            null
          );
          const closeLabel = this.#rmp.labels.hint.close;
          const modulesClose = this.close.bind(this, type, false);
          FW.addEvents(['touchend', 'click'], overlayCloseButton, modulesClose);
          overlayMenuSelection.appendChild(overlayCloseButton);
          this.#rmp.rmpAccessible.button(overlayCloseButton, closeLabel, true);
        }
      }
      this.#rmp.rmpModuleManagement.updatePlayPauseUI(this.#rmp.paused);
      // set active module type in module selection UI
      this.#setActiveModuleInModuleSelection();
    }
  }

  #setActiveModuleInModuleSelection() {
    const className = this.#rmp.dom.container.className;
    let activeModuleType;
    if (className) {
      const regExp = /rmp-module-overlay-(quality|sharing|audio|captions|speed|related|chapters|info)/i;
      const type = className.match(regExp);
      if (type && type[1]) {
        activeModuleType = type[1];
      }
    }
    if (activeModuleType) {
      const activeModuleOverlay = this.#rmp.dom.container.querySelector('.rmp-module-overlay[data-type="' + activeModuleType + '"]');
      if (activeModuleOverlay) {
        const moduleButton = activeModuleOverlay.querySelector('.rmp-i-' + activeModuleType);
        if (moduleButton) {
          moduleButton.classList.add('rmp-module-overlay-icons-active');
        }
      }
    }
  }

  appendHint(type, label) {
    const hint = FW.createElement('div', 'rmp-module-hint rmp-color-bg', label);
    this.#rmp.dom[type].appendChild(hint);
  }

  destroy(type) {
    if (type === 'quality') {
      if (this.#rmp.rmpPDQuality) {
        this.#rmp.rmpPDQuality.destroy();
      }
    }
    FW.removeElement(this.#rmp.dom[type]);
    FW.removeElement(this.#rmp.dom[type + 'Overlay']);
  }

  open(type, immediate, event) {
    FW.eventStopPrevent(event);
    // close all modules
    this.closeAll();
    this.#rmp.dom.container.classList.add('rmp-module-overlay-' + type, 'rmp-module-overlay-open');
    this.appendModuleSelection();
    let paused;
    if (this.#rmp.linearAdOnStage) {
      paused = this.#rmp.adPaused;
    } else {
      paused = this.#rmp.paused;
    }
    if (paused) {
      this.#rmp.dom[type + 'OverlayPlayPause'].classList.replace('rmp-i-pause', 'rmp-i-play');
    } else {
      this.#rmp.dom[type + 'OverlayPlayPause'].classList.replace('rmp-i-play', 'rmp-i-pause');
    }

    // hide UI When Module Is Opened() 
    this.#rmp.dom.container.classList.add('rmp-module-open-ui');
    if (this.#rmp.googleCastConnected) {
      this.#rmp.dom.container.classList.add('rmp-casting-module-overlay-open');
    }

    FW.fadeIn(this.#rmp.dom[type + 'Overlay'], immediate);
  }

  close(type, immediate, event) {
    if (!FW.isVisible(this.#rmp.dom[type + 'Overlay'])) {
      return;
    }
    FW.eventStopPrevent(event);
    // restore CC module to default >> FCC closed
    if (type === 'captions' && this.#rmp.dom.captionsOverlayFCCSettingsArea &&
      this.#rmp.dom.captionsOverlayFCCSettingsArea.style.display === 'flex' && this.#rmp.rmpFccCaptions) {
      this.#rmp.rmpFccCaptions.displaySettings();
    }

    // show UI When Module Closes
    this.#rmp.dom.container.classList.remove('rmp-module-open-ui');
    if (this.#rmp.googleCastConnected) {
      this.#rmp.dom.container.classList.remove('rmp-casting-module-overlay-open');
    }
    this.#rmp.rmpUIManagement.showChrome();

    FW.fadeOut(this.#rmp.dom[type + 'Overlay'], immediate);
    this.#rmp.dom.container.classList.remove('rmp-module-overlay-' + type, 'rmp-module-overlay-open');
  }

  closeAll() {
    if (this.#rmp.dom.container.classList.contains('rmp-module-overlay-open')) {
      const modulePattern = /rmp-module-overlay-(quality|audio|captions|sharing|speed|related|chapters|info)/i;
      const type = this.#rmp.dom.container.className.match(modulePattern);
      if (type && type[1]) {
        const typeOpen = type[1];
        this.close(typeOpen, true);
      }
    }
  }

  updatePlayPauseUI(paused) {
    let label;
    this.#openableTypes.forEach(module => {
      if (this.#rmp.dom[module + 'OverlayPlayPause']) {
        if (paused) {
          this.#rmp.dom[module + 'OverlayPlayPause'].classList.replace('rmp-i-pause', 'rmp-i-play');
          label = this.#rmp.labels.hint.play;
        } else {
          this.#rmp.dom[module + 'OverlayPlayPause'].classList.replace('rmp-i-play', 'rmp-i-pause');
          label = this.#rmp.labels.hint.pause;
        }
        this.#rmp.dom[module + 'OverlayPlayPause'].setAttribute('aria-label', label);
      }
    });
  }

  appendToControlBar(type) {
    const label = this.#rmp.labels.hint[type];
    const keyboardShortcutLabel = this.#rmp.labels.hint.keyboardShortcut;
    if (type === 'audio') {
      this.#rmp.dom.container.classList.add('rmp-audio-ui');
    } else if (type === 'captions') {
      this.#rmp.dom.container.classList.add('rmp-captions-ui');
    }
    let className = 'rmp-button rmp-' + type + ' rmp-i rmp-i-' + type;
    if (this.#rmp.readingHls && type === 'quality') {
      className = 'rmp-button rmp-' + type;
    }
    this.#rmp.dom[type] = FW.createElement(
      'button',
      className,
      null,
      null
    );
    if (!this.#rmp.isMobile) {
      this.#rmp.dom[type].addEventListener('mouseenter', event => {
        if (event) {
          event.stopPropagation();
        }
        this.#rmp.forceResetTimer = true;
      });
      this.#rmp.dom[type].addEventListener('mouseleave', event => {
        if (event) {
          event.stopPropagation();
        }
        this.#rmp.forceResetTimer = false;
      });
    }
    if (type === 'quality' && this.#rmp.readingMse) {
      this.#rmp.dom.qualityHD = FW.createElement('span', 'rmp-quality-hd');
      this.#rmp.dom[type].appendChild(this.#rmp.dom.qualityHD);
    }
    this.#rmp.dom[type].addEventListener('dblclick', FW.stopPropagation);
    let completeLabel = label;
    let ariaLabel = label;
    let keyboardShortcut = null;
    if (type === 'captions') {
      completeLabel += ' (c)';
      keyboardShortcut = 'c';
      ariaLabel += ' ' + keyboardShortcutLabel + ' c';
    } else if (type === 'audio') {
      completeLabel += ' (a)';
      keyboardShortcut = 'a';
      ariaLabel += ' ' + keyboardShortcutLabel + ' a';
    }
    this.#rmp.dom[type + 'Hint'] = FW.createElement(
      'div',
      'rmp-control-bar-hint rmp-color-bg',
      completeLabel,
      this.#rmp.rtl
    );
    this.#rmp.dom[type].appendChild(this.#rmp.dom[type + 'Hint']);
    // for accessibility purposes - tab key - we need to make sure icons in right side of control bar are appended in 
    // order
    const fullscreenElement = this.#rmp.dom.controlBar.querySelector('.rmp-fullscreen');
    if (fullscreenElement) {
      const qualityElement = this.#rmp.dom.controlBar.querySelector('.rmp-quality');
      if (qualityElement && type !== 'quality') {
        const audioElement = this.#rmp.dom.controlBar.querySelector('.rmp-audio');
        const captionsElement = this.#rmp.dom.controlBar.querySelector('.rmp-captions');
        if (audioElement && type !== 'audio') {
          FW.insertBefore(this.#rmp.dom.controlBar, this.#rmp.dom[type], audioElement);
        } else if (captionsElement && type !== 'captions') {
          FW.insertBefore(this.#rmp.dom.controlBar, this.#rmp.dom[type], captionsElement);
        } else {
          FW.insertBefore(this.#rmp.dom.controlBar, this.#rmp.dom[type], qualityElement);
        }
      } else {
        FW.insertBefore(this.#rmp.dom.controlBar, this.#rmp.dom[type], fullscreenElement);
      }
    } else {
      this.#rmp.dom.controlBar.appendChild(this.#rmp.dom[type]);
    }
    if (this.#rmp.readingHls && type === 'quality') {
      this.#rmp.dom.qualityIndicator = FW.createElement('span', 'rmp-quality-indicator');
      this.#rmp.dom[type].appendChild(this.#rmp.dom.qualityIndicator);
      FW.setText(this.#rmp.dom.qualityIndicator, 'Auto');
    }
    this.#rmp.rmpAccessible.button(this.#rmp.dom[type], ariaLabel, true, null, keyboardShortcut);
  }

  appendToModuleBar(type) {
    let label = '';
    let icon;
    switch (type) {
      case 'cast':
        label = 'Google Cast';
        if (this.#rmp.googleCastCordova) {
          icon = FW.createElement('span', 'rmp-i rmp-i-google-cast');
        } else {
          icon = document.createElement('google-cast-launcher');
        }
        break;
      case 'pip':
        label = 'PiP';
        break;
      case 'airplay':
        label = 'AirPlay';
        break;
      default:
        label = this.#rmp.labels.hint[type];
        break;
    }
    if (!icon) {
      icon = FW.createElement('span', 'rmp-i rmp-i-' + type);
    }
    this.#rmp.dom[type] = FW.createElement(
      'button',
      'rmp-button rmp-' + type + ' rmp-module rmp-color-bg',
      null,
      null
    );
    if (!this.#rmp.isMobile) {
      this.#rmp.dom[type].addEventListener('mouseenter', event => {
        if (event) {
          event.stopPropagation();
        }
        this.#rmp.forceResetTimer = true;
      });
      this.#rmp.dom[type].addEventListener('mouseleave', event => {
        if (event) {
          event.stopPropagation();
        }
        this.#rmp.forceResetTimer = false;
      });
    }
    const innerDiv = FW.createElement('div', 'rmp-module-button');
    innerDiv.appendChild(icon);
    this.#rmp.dom[type].appendChild(innerDiv);
    if ((type === 'cast' || type === 'airplay') && this.#rmp.audioOnly) {
      this.#rmp.dom.controlBar.appendChild(this.#rmp.dom[type]);
    } else {
      this.#rmp.dom.moduleArea.appendChild(this.#rmp.dom[type]);
    }
    this.#rmp.dom[type].addEventListener('dblclick', FW.stopPropagation);
    this.appendHint(type, label);
    this.#rmp.rmpAccessible.button(this.#rmp.dom[type], label, true);
  }

  appendOverlay(type) {
    // overlay background
    this.#rmp.dom[type + 'Overlay'] = FW.createElement('div', 'rmp-module-overlay');
    this.#rmp.dom[type + 'Overlay'].setAttribute('data-type', type);
    FW.addEvents(['touchend', 'click'], this.#rmp.dom[type + 'Overlay'], FW.stopPropagation);
    this.#rmp.dom.moduleOverlaysArea.appendChild(this.#rmp.dom[type + 'Overlay']);

    // overlay wrapper
    this.#rmp.dom[type + 'OverlayWrapper'] = FW.createElement('div', 'rmp-overlay-wrapper');
    this.#rmp.dom[type + 'Overlay'].appendChild(this.#rmp.dom[type + 'OverlayWrapper']);

    // Module Selection wrapper
    const overlayMenuSelection = FW.createElement('div', 'rmp-overlay-menu-selection');
    this.#rmp.dom[type + 'OverlayWrapper'].appendChild(overlayMenuSelection);

    // levels area
    this.#rmp.dom[type + 'OverlayLevelsArea'] = document.createElement('div');
    if (type !== 'related') {
      this.#rmp.dom[type + 'OverlayLevelsArea'].className = 'rmp-overlay-levels-area';
    }
    this.#rmp.dom[type + 'OverlayWrapper'].appendChild(this.#rmp.dom[type + 'OverlayLevelsArea']);
    const modulesOpen = this.open.bind(this, type, false);
    FW.addEvents(['touchend', 'click'], this.#rmp.dom[type], modulesOpen);
    //fcc settings
    if (type === 'captions') {
      this.#rmp.rmpFccCaptions = new FccCaptions(this.#rmp);
      this.#rmp.rmpFccCaptions.init();
    }
  }

  setActiveLevel(type, newLevelIndex) {
    if (this.#rmp.dom[type + 'OverlayLevelsArea']) {
      const levels = this.#rmp.dom[type + 'OverlayLevelsArea'].querySelectorAll('.rmp-overlay-level');
      if (levels.length > 0) {
        for (let i = 0, len = levels.length; i < len; i++) {
          levels[i].classList.remove('rmp-overlay-level-active');
        }
        levels[newLevelIndex].classList.add('rmp-overlay-level-active');
      }
    }
  }

}
